var _style, _circle, _path, _path2, _path3, _path4, _polygon;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQwtLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:#FFD103;}\r\n\t.st2{fill:url(#XMLID_6_);}\r\n\t.st3{fill:url(#XMLID_7_);}\r\n\t.st4{fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 3.4995,
    y1: 77.672,
    x2: 196.4675,
    y2: 122.2222
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4EAD9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.287,
    style: {
      stopColor: "#57B1A0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7479,
    style: {
      stopColor: "#6EBCA5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7EC4A9"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 100,
    cy: 99.9,
    r: 99
  })), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    className: "st1",
    d: "M77.7,123.3c-0.7-0.2-1.4-0.5-2.2-0.9C76.2,122.7,76.9,123,77.7,123.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 73.32,
    y1: 93.7382,
    x2: 146.1722,
    y2: 93.7382
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D9D9D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3_",
    className: "st2",
    d: "M144,66.3c-1.4-3.2-3.4-6.1-6-8.5c-2.6-2.4-5.5-4.3-8.9-5.7c-3.4-1.4-7-2-11-2H92.9 c-10,4.5-16,11-19.6,16.4c2.4-1.9,5.2-2.9,8.5-2.9h36.3c3.8,0,7,1.3,9.6,3.8c2.6,2.5,3.9,5.6,3.9,9V111c0,1.8-0.4,3.5-1.1,5 c-1.3,3.8-5.5,13.8-17.1,21.4h4.6c3.9,0,7.6-0.7,11-2c3.4-1.4,6.4-3.2,8.9-5.7c2.6-2.4,4.6-5.2,6-8.4c1.4-3.2,2.1-6.6,2.1-10.3 V82.7v-6.2C146.2,72.9,145.5,69.5,144,66.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    className: "st1",
    d: "M75.5,122.4c0.7,0.4,1.4,0.6,2.2,0.9C77,123,76.3,122.7,75.5,122.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 131.0552,
    y1: 115.6714,
    x2: 50.4296,
    y2: 78.072
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C6C6C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1_",
    className: "st3",
    d: "M118.1,123.9H81.8c-1.5,0-2.9-0.2-4.2-0.6c-0.8-0.2-1.5-0.5-2.2-0.9c-1.2-0.6-2.3-1.4-3.3-2.4 c-2.6-2.5-4-5.6-4-9V76.5c0-3.5,1.3-6.5,4-9c0.4-0.3,0.7-0.7,1.1-1c3.5-5.4,9.6-11.9,19.6-16.4H81.8c-3.9,0-7.5,0.7-10.9,2 c-3.4,1.4-6.4,3.2-9,5.7c-2.6,2.4-4.6,5.3-6,8.5c-1.4,3.2-2.1,6.6-2.1,10.2v25.8v8.8c0,3.7,0.7,7.1,2.1,10.3c1.4,3.2,3.4,6,6,8.4 c2.6,2.4,5.6,4.3,9,5.7c3.4,1.4,7.1,2,10.9,2h11.6h13.1h7c11.6-7.6,15.8-17.5,17.1-21.4c-0.7,1.4-1.6,2.8-2.9,4 C125.2,122.6,122,123.9,118.1,123.9z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "93,110.2 93,149.8 93.4,149.8 106.5,149.8 107,149.8 107,103.5  "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQwtLogo);
export default __webpack_public_path__ + "static/media/qwt-logo.4e1dc39a5ea4004134050822ef66d0ab.svg";
export { ForwardRef as ReactComponent };